export default __webpack_public_path__ + "static/media/Android.9e564aff.svg";